import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthRefreshTokenInterface } from './definitions/auth-refresh-token.interface';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';
import { ConfigService } from '../../config/config.service';

@Injectable()
export class AuthRefreshTokenService {

  private client: HttpClient;

  constructor(private httpBackend: HttpBackend, private configService: ConfigService) {
    this.client = new HttpClient(httpBackend); // Bypass interceptors
  }

  public refreshToken(refreshToken: string): Observable<AuthRefreshTokenInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/auth/refresh-token`;

    return this.client.post<AuthRefreshTokenInterface>(url, { token: refreshToken }).pipe(
      catchError(error => throwError(handleProblem(error))),
    );
  }
}
